<template>
  <div v-if="item.trackBestBeforeDate && bestBefore" style="height: 32px" class="align-content-center">
    <img v-if="showIcon" src="/mat-sig/expiry.svg" alt="Best before" class="align-bottom mx-1" style="height: 1.4em;">
    {{ $d(new Date(bestBefore), 'dateonly') }}
  </div>
  <div v-else style="height: 32px">&nbsp;</div>
</template>

<script setup lang="ts">
import Item from '@/models/frontend/Item';

defineProps({
  item: { type: Object as () => Item, required: true },
  bestBefore: { type: String, required: false },
  showIcon: { type: Boolean, default: false }
});
</script>
